import * as React from 'react';

const Lt16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F1B72D", d: "M1.127 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.333h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2D6B46", d: "M1.127 6.333h14v3.334h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#B01F35", d: "M1.127 9.667h14V11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z" }));
Lt16.Size = 16;
Lt16.Title = "Lt";

export { Lt16 as default };
